// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUsers } from '@tabler/icons';

const adminUsers = {
    id: 'admin-users',
    title: <FormattedMessage id="admin-users" />,
    icon: IconUsers,
    type: 'group',
    url: 'users',
    roles: ['admin']
};

export default adminUsers;
